import messageResource from '../../messageResource'

export default function BaseColumnsStrategy() {}

BaseColumnsStrategy.prototype.init = function()
{
    return this;
};

BaseColumnsStrategy.prototype.addCell = function ( row, notEscapedContent, className, colSpan, rowSpan )
{
    ReportPreviewUtils.addCell( row, notEscapedContent, className, colSpan, rowSpan );
};

BaseColumnsStrategy.prototype.addCreatedCell = function ( row, cell )
{
    ReportPreviewUtils.addCreatedCell( row, cell );
};

BaseColumnsStrategy.prototype.message = function ( key, params )
{
    return messageResource.getMessage( key, params );
};

BaseColumnsStrategy.prototype.addTimeValueCell = function ( row, className )
{
    row.appendChild( this.createTimeValueCell( className ) );
};

BaseColumnsStrategy.prototype.addMoneyValueCell = function ( row, className )
{
    this.addCell( row, SystemSettings.currencySign, "moneyValueCell " + ( className ? className : "" ) );
};

BaseColumnsStrategy.prototype.createTimeValueCell = function ( className )
{
    // abstract
};

BaseColumnsStrategy.prototype.makeTimeValue = function()
{
    // abstract
};




// WEBPACK FOOTER //
// ./web/js/reports/preview/BaseColumnsStrategy.js